import { fetchJSON as fetchAPI } from './client';

export type IQADashboardSnapshot = {
  tenant_id: string; overall_quality_score: number; conflict_count: number;
  pending_review: number; blocked_by_safety: number; evidence_coverage_pct: number;
  approval_rate_pct: number; quality_trend: string; generated_at: string;
};

export type QAQueueItem = {
  id: string; source: string; title: string; status: string;
  quality_score: number; safety_score: number; conflict_flag?: boolean; evidence_complete: boolean;
};

export type ConflictEntry = {
  id: string; type: string; severity: string; title: string;
  recommendation_ids: string[]; status: string; resolution?: string;
};

export type ConsolidatedRecommendation = {
  id: string; title: string; merged_from: string[]; sources: string[];
  quality_score: number; expected_impact: string; status: string;
};

export type QualityScoreBreakdown = {
  recommendation_id: string; evidence_score: number; confidence_score: number;
  business_impact_score: number; risk_score: number; explainability_score: number;
  freshness_score: number; overall_quality_score: number;
};

export type SafetyAssessment = {
  recommendation_id: string; safety_score: number; passed: boolean;
  flags?: string[]; blocked_reason?: string;
};

export type GovernanceDecision = {
  id: string; recommendation_id: string; action: string; actor: string;
  reason?: string; timestamp: string;
};

export type QualityTrend = {
  period: string; quality_score: number; conflict_rate: number;
  evidence_coverage: number; approval_rate: number;
};

export type IQALearningUpdate = { id: string; target: string; action: string; impact: string; timestamp: string };
export type IQATimelineEvent = { id: string; type: string; title: string; actor: string; timestamp: string };

const COMMAND_BASE = import.meta.env.VITE_COMMANDCENTER_API ?? '/api/v1/command';
const fetchC = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${COMMAND_BASE}${path}`, init);

export const intelligenceQAApi = {
  dashboard: () => fetchC<IQADashboardSnapshot>('/intelligence-qa/dashboard'),
  queue: () => fetchC<{ queue: QAQueueItem[] }>('/intelligence-qa/queue').then((r) => r.queue),
  conflicts: () => fetchC<{ conflicts: ConflictEntry[] }>('/intelligence-qa/conflicts').then((r) => r.conflicts),
  consolidation: () => fetchC<{ consolidated: ConsolidatedRecommendation[] }>('/intelligence-qa/consolidation').then((r) => r.consolidated),
  quality: (id: string) => fetchC<QualityScoreBreakdown>(`/intelligence-qa/quality/${id}`),
  safety: (id: string) => fetchC<SafetyAssessment>(`/intelligence-qa/safety/${id}`),
  decisions: () => fetchC<{ decisions: GovernanceDecision[] }>('/intelligence-qa/decisions').then((r) => r.decisions),
  trends: () => fetchC<{ trends: QualityTrend[] }>('/intelligence-qa/trends').then((r) => r.trends),
  learning: () => fetchC<{ updates: IQALearningUpdate[] }>('/intelligence-qa/learning').then((r) => r.updates),
  history: () => fetchC<{ events: IQATimelineEvent[] }>('/intelligence-qa/history').then((r) => r.events),
};
